import React, { useState } from "react";
import { X, Check } from "lucide-react";

const inputCls = "w-full rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-primary)] px-4 py-3 text-sm text-[var(--text-primary)] outline-none focus:border-[var(--accent-gold)]";

export const VisitorModal = ({ open, onClose, title, subtitle, submitLabel, onSubmit, withDate }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", date: "", time: "11:00 AM", notes: "" });
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.name.trim()) errs.name = "Name required";
    if (!/^[+\d][\d\s-]{7,}$/.test(form.phone)) errs.phone = "Valid phone required";
    if (form.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) errs.email = "Valid email required";
    if (withDate && !form.date) errs.date = "Pick a date";
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setBusy(true);
    try { await onSubmit(form); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm" onClick={onClose} data-testid="visitor-modal">
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="w-full max-w-md rounded-2xl border border-[var(--border-subtle)] bg-[var(--bg-card)] p-6 shadow-2xl">
        <div className="mb-4 flex items-start justify-between">
          <div><h3 className="font-serif text-2xl text-[var(--text-primary)]">{title}</h3><p className="mt-1 text-sm text-[var(--text-muted)]">{subtitle}</p></div>
          <button type="button" onClick={onClose} className="rounded-full p-1.5 text-[var(--text-muted)] hover:bg-[var(--bg-primary)]"><X className="h-5 w-5" /></button>
        </div>
        <div className="space-y-3">
          <div><input placeholder="Your name" value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="visitor-name" className={inputCls} />{errors.name && <p className="mt-1 text-xs text-red-500">{errors.name}</p>}</div>
          <div><input placeholder="Phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} data-testid="visitor-phone" className={inputCls} />{errors.phone && <p className="mt-1 text-xs text-red-500">{errors.phone}</p>}</div>
          <div><input placeholder="Email (optional)" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="visitor-email" className={inputCls} />{errors.email && <p className="mt-1 text-xs text-red-500">{errors.email}</p>}</div>
          {withDate && (
            <div className="grid grid-cols-2 gap-3">
              <div><input type="date" value={form.date} min={new Date().toISOString().slice(0, 10)} onChange={(e) => set("date", e.target.value)} data-testid="visitor-date" className={inputCls} />{errors.date && <p className="mt-1 text-xs text-red-500">{errors.date}</p>}</div>
              <select value={form.time} onChange={(e) => set("time", e.target.value)} data-testid="visitor-time" className={inputCls}>{["10:00 AM", "11:00 AM", "12:00 PM", "2:00 PM", "4:00 PM", "5:00 PM"].map((t) => <option key={t}>{t}</option>)}</select>
            </div>
          )}
          <textarea rows={2} placeholder="Anything we should know? (optional)" value={form.notes} onChange={(e) => set("notes", e.target.value)} data-testid="visitor-notes" className={inputCls} />
        </div>
        <button type="submit" disabled={busy} data-testid="visitor-submit" className="btn-gold mt-5 w-full disabled:opacity-60">{busy ? "Sending…" : submitLabel} <Check className="h-4 w-4" /></button>
      </form>
    </div>
  );
};

export default VisitorModal;
